var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocDocx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 71,
    viewBox: "0 0 72 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_810_5250)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8887 6.19841V64.8016C17.8887 68.2249 20.6204 71 23.9902 71H65.0371C68.4069 71 71.1387 68.2249 71.1387 64.8016V16.3106C71.1387 14.6549 70.4866 13.068 69.3278 11.9037L59.2635 1.79145C58.1213 0.643726 56.5795 0 54.9729 0H23.9902C20.6204 0 17.8887 2.77512 17.8887 6.19841ZM21.7715 64.8016V6.19841C21.7715 4.95358 22.7649 3.94444 23.9902 3.94444H54.2207V17.4683C54.2207 19.8023 56.0833 21.6944 58.3809 21.6944H67.2559V64.8016C67.2559 66.0464 66.2625 67.0556 65.0371 67.0556H23.9902C22.7649 67.0556 21.7715 66.0464 21.7715 64.8016ZM67.2559 17.75V16.3106C67.2559 15.7085 67.0187 15.1315 66.5974 14.7081L58.1035 6.17377V17.4683C58.1035 17.6239 58.2277 17.75 58.3809 17.75H67.2559Z",
    fill: "#9D9C9B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.623 29.1211C45.623 28.0489 46.4922 27.1797 47.5645 27.1797H60.3223C61.3945 27.1797 62.2637 28.0489 62.2637 29.1211C62.2637 30.1933 61.3945 31.0625 60.3223 31.0625H47.5645C46.4922 31.0625 45.623 30.1933 45.623 29.1211Z",
    fill: "#6BB3EC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.623 37.9961C45.623 36.9239 46.4922 36.0547 47.5645 36.0547H60.3223C61.3945 36.0547 62.2637 36.9239 62.2637 37.9961C62.2637 39.0683 61.3945 39.9375 60.3223 39.9375H47.5645C46.4922 39.9375 45.623 39.0683 45.623 37.9961Z",
    fill: "#508FD6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.623 46.8711C45.623 45.7989 46.4922 44.9297 47.5645 44.9297H60.3223C61.3945 44.9297 62.2637 45.7989 62.2637 46.8711C62.2637 47.9433 61.3945 48.8125 60.3223 48.8125H47.5645C46.4922 48.8125 45.623 47.9433 45.623 46.8711Z",
    fill: "#3770C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.138672 20.5234C0.138672 18.6854 1.62872 17.1953 3.4668 17.1953H36.748C38.5861 17.1953 40.0762 18.6854 40.0762 20.5234V53.8047C40.0762 55.6428 38.5861 57.1328 36.748 57.1328H3.4668C1.62872 57.1328 0.138672 55.6428 0.138672 53.8047V20.5234Z",
    fill: "#3770C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2573 47.7508L7.9043 25.5156H11.6809L14.411 40.789L17.7478 25.5156H22.1312L25.3315 41.0469L28.1374 25.5156H31.8382L27.4094 47.7508H23.4962L19.8561 31.1275L16.2463 47.7508H12.2573Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_810_5250"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 71,
    height: 71,
    fill: "white",
    transform: "translate(0.138672)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocDocx);
export default __webpack_public_path__ + "static/media/doc-docx.882192c89ac6102ecb504ab2384b4191.svg";
export { ForwardRef as ReactComponent };